import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AetSafetyDashboardService } from 'src/app/services/aet-safety-dashboard.service';

@Component({
    selector: 'app-close-event',
    templateUrl: './close-event.component.html',
    styleUrls: ['./close-event.component.scss'],
    standalone: false // NOSONAR
})
export class CloseEventComponent implements OnInit {
  errormsg;
  heading;
  description;
  submit;

  constructor(
    public dialogRef: MatDialogRef<CloseEventComponent>,
    @Inject(MAT_DIALOG_DATA) public dataStore: any,
     private readonly aetSafetyDashboardService : AetSafetyDashboardService
  ) {}

  ngOnInit(): void {
    this.heading = this.dataStore.header;
    this.description = this.dataStore.description;
    if(this.dataStore.event  == 'close')  // NOSONAR
    {
      (this.submit = 'Close Event')
    }
    else{
       (this.submit = 'Delete Event')
    }
    
  }

  close() {
    this.dialogRef.close({
      event: '',
      data: '',
    });
  }

  saveClick() {
    if (this.dataStore?.event == 'delete') {  // NOSONAR
      this.aetSafetyDashboardService.deleteEvent(this.dataStore.id).subscribe(
        (response) => {
          if (response == 'Success') {  // NOSONAR
            this.dialogRef?.close({
              event: 'SaveEvent',
              data: 'success',
            });
          } else {
            this.dialogRef?.close({
              event: 'SaveEvent',
              data: 'failure',
            });
          }
        },
        (error) => {
          console.info(error);
        }
      );
    } else if (this.dataStore?.event == 'close') {  // NOSONAR
      this.aetSafetyDashboardService.closeEvent(this.dataStore.id).subscribe(
        (response) => {
          if (response == 'Success') {  // NOSONAR
            this.dialogRef.close({
              event: 'SaveEvent',
              data: 'success',
            });
          } else if (response == 'Error'){  // NOSONAR
            this.dialogRef.close({
              event: 'SaveEvent',
              data: 'failure',
            });
          } else{
            this.dialogRef.close({
              event: 'SaveEvent',
              data: response,
            });
          }
        },
        (error) => {
          console.info(error);
        }
      );
    }
  }

}
